import type { AxiosResponse } from 'axios';
import type { MutationError, ValidationError } from '~/types/form';

export const handleErrorResponse = async (
  response: AxiosResponse,
): Promise<MutationError> => {
  // If its not a validation error, return a simple error.
  if (response.status !== 422) {
    return new Error(response.statusText);
  }

  const responseJson = response.data;

  // Create a custom error object with the response from the server,
  // so we can access the errors in the component.
  const error = new Error(responseJson?.message ?? response.statusText) as ValidationError;

  error.validationErrors = responseJson?.errors ?? null;

  throw error;
};
